export default __webpack_public_path__ + "bd409e6bb4a0fe8e6bd05a533e17f6d8.svg";